import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import DataSetOperators from 'interfaces/DataSetOperators';
import { Entities } from 'models/Entities';
import { Link } from 'models/Link';
import { ApiService } from 'services/ApiService';

export const useDocumentLinks = (apiBaseUrl: string) => {
  const defaultLinks: Array<Link> = [
    { name: 'Select...', url: false },
    { name: 'Home', url: '/' },
  ];
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
  const [predefinedLinks, setPredefinedLinks] = useState<Array<Link>>(defaultLinks);
  const scheduleService = new ApiService<Link>(apiBaseUrl, Entities.Documents);

  useEffect(() => {
    if (!isAuthenticated || isLoading) {
      return;
    }

    const fetchData = async () => {
      const token = await getAccessTokenSilently();
      if (token) {
        scheduleService.setAccessToken(token);
        const ops: DataSetOperators = {};
        const links = [...defaultLinks];
        const serverLinks = (await scheduleService.all(ops, 'Links')) as Link[];
        links.push(...serverLinks);
        setPredefinedLinks(links);
      }
    };

    fetchData().catch((e) => {
      throw e;
    });
  }, [isAuthenticated, isLoading]);

  return predefinedLinks;
};
